import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const updateServerLifecycle = (inputData) => async (dispatch) => {
    try {
        dispatch({
            type: Actions.LOADING_UPDATE_SERVER_LIFE_CYCLE,
            payload: true
           })

        const { data } = await api.updateServerLifecycle(inputData);

        if (data.code === 200) {
            dispatch({
             type: Actions.LOADING_UPDATE_SERVER_LIFE_CYCLE,
             payload: false
            })
         }
       
        dispatch({
            type: Actions.UPDATE_SERVER_LIFE_CYCLE,
            payload: data
        })
    } catch (error) {
        console.log(error);
        dispatch({
            type: Actions.LOADING_UPDATE_SERVER_LIFE_CYCLE,
            payload: false
           })
    }
}